<template>
<div>
    <div :class="wrapper_class">
        <div :class="list_class" class="position-relative files_list_container" :id="list_container_id">
            <div v-show="loader" class="chart-loader"><div><i class="fad fa-circle-notch fa-spin fa-4x"></i></div></div>
            <div v-for="(item,key) in list" :key="key" class="note-wrap">
                <div class="note-author p-1">{{ item.user_name }} - {{ dateFormat(item.created_at) }}:</div>
                <a :href="filePath(item.hash)" target="_blank">{{ item.name }}</a>
            </div>
        </div>
    </div>

</div>
</template>

<script>

import field from '@/mixins/field';
import formatting from '@/mixins/formatting'

export default {
    props: ['value','slug','hash','name','reload','direction', 'data'],
    mixins: [formatting],
    data() {
        return {
            loader: false,
            disabled: false,
            newValue: null,
            list: [],
            wrapper_class: 'd-flex',
            txta_class: 'w-50',
            list_class: 'w-50 pl-2'
        }
    },
    computed: {
        list_container_id() {
            return 'files_list_container_' + this.name;
        }
    },
    watch: {
        value(val) {
            this.newValue = val;
        },
        reload(reload) {
            if (reload) {
                this.newValue = null
                this.emitInput();
                this.load()
            }
        }
    },
    methods: {
        load() {
            this.loader = true;
            axios.post('/d/files/list',
                {
                    form_hash: this.hash,
                    field_name: this.name,
                    slug: this.slug
                })
                .then((res) => {
                   this.list = res.data
                   this.loader = false;
                   document.getElementById(this.list_container_id).scroll({top:0,behavior:'smooth'});
                })
        },
        emitInput() {
            this.$emit('input', this.newValue )
        },
        filePath(hash) {
          return '/view_file/' + hash;
        },
    },
    mounted() {
        this.load();
        if (this.direction == 'vertical') {
            this.wrapper_class  = 'd-flex flex-column',
            this.txta_class     = '',
            this.list_class     = 'mt-2'
        }
    }
}
</script>

<style scoped>
.input-field {
    height: 100px;
}
.note-detail {
    -webkit-transition: max-height 0.7s;
    -moz-transition: max-height 0.7s;
    -ms-transition: max-height 0.7s;
    -o-transition: max-height 0.7s;
    transition: max-height 0.7s;
    overflow: hidden;
    max-height: 60px;
    overflow: hidden;
}
.note-wrap:hover .note-detail {
    max-height: 157px;
    overflow: auto;
}
.note-wrap {
    padding-left: 10px;
    border-left: 1px dashed #6f2971;
    position: relative;
}
.note-wrap::before {
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    -moz-border-radius: 4px;
    -webkit-border-radius: 16px;
    border-radius: 16px;
    background-color: #6f2971;
    position: absolute;
    left: -4px;
    top: 10px;
}
.files_list_container {
    padding-left: 5px;
}
</style>